import HorizontalTab, { TabItem } from "../components/navigation/shared/HorizontalTab";
import { ReactNode } from "react";
import { Layout } from "./DashboardLayout";

export interface CountryTransfert {
  code: string; // Code pays: "CM", "BJ", "CI", etc.
  label: string; // Libellé: "Cameroun", "Bénin", etc.
  flag?: string; // Emoji drapeau ou URL
  count?: number; // Nombre de transferts
}

interface BankTransfertsLayoutProps {
  onDirectionChange: (direction: string) => void;
  currentDirection?: string;
  children: ReactNode;
}

export default function BankTransfertsLayout({
  onDirectionChange,
  currentDirection = "all",

  children,
}: BankTransfertsLayoutProps) {
  // Configuration des onglets par direction
  const tabItems: TabItem[] = [
    {
      label: `Canada-Cameroun`,
      value: "canada-cmr-banque",
    },
  ];

  const handleTabChange = (value: string) => {
    onDirectionChange(value);
  };

  return (
    <Layout>
      <div className="mb-8">
        <h1 className="mb-2 text-3xl font-bold text-gray-800"> Transferts bancaires</h1>
        <p className="text-gray-600">Gérez les transferts bancaires </p>
      </div>

      <HorizontalTab
        tabItems={tabItems}
        onChange={handleTabChange}
        defaultValue={currentDirection}
        showScrollButtons={true}
        className="w-full"
      />

      {children}
    </Layout>
  );
}
